<template>
    <li class="dialog-tree-row">
        <div v-show="!loading">
            <div v-if="!editing && $store.claims.dialogs & 1 && $store.claims.phrases & 2"  class="edit-icons">
                <div class="icon-container">
                    <i v-if="!isStart" class='material-icons right grey-text text-darken-1' @click="edit()">edit</i>
                </div>
            </div>
            <div :id="dialog.id" @click="toggle" v-if="!editing" class="text-preview" v-bind:class="{'grey-text text-darken-1': isStart}">
                <span v-if="!isStart" class="number-badge">{{itemNumber}}</span>
                <i class="material-icons " v-bind:class="{'outline': open && !isStart, 'helen-green-text': !isStart}">{{icon}}</i>
                <div class="preview-div">
                {{ primaryTranslation }}
                
                <div v-if="!isStart" dir="auto" class="secondary-language" :id="'secondary-translation-' + dialog.id">{{ secondaryTranslation }}</div>

                </div>

               <div  v-for="(phrase, index) in currentPhraseList" :key="'phrase.id' + index" style="display: flex;flex-direction: column">
                   <div :id="phrase.id + '_' + index + $parent.dialog.id +'_' + 'span'"  style="display:flex;justify-content: space-between;margin-top:10px">
                        <span style="white-space:pre-line;margin-left: 25px">{{primaryPraragraphTranslation(phrase)}}</span>
                       <i @click="editParagraph(phrase,index)" class="material-icons prefix grey-text text-darken-1" style="margin-top: 5px">edit</i>
                    </div>
                    <div :id="phrase.id + '_' + index + $parent.dialog.id +'_' + 'editbox'" style="margin-top:10px; display:none" >
                        <textarea :ref="phrase.id + '_' + index + 'textarea'" class="preview-div-2" style="padding-left:28px;border:0px black !important;color:black" :value="primaryPraragraphTranslation(phrase)" />
                        <i @click="undoEditParagraph(phrase,index)" class="material-icons prefix grey-text text-darken-1" style="margin-top: 5px">undo</i>
                        <i @click="savePhrase(phrase,index)" class="material-icons prefix grey-text text-darken-1" style="margin-top: 5px">save</i>
                    </div>
                    <div v-if="!isStart" class="secondary-language" style="white-space:pre-line;margin-left: 25px" >{{secondaryParagraphTranslation(phrase)}}</div>
                </div>
            </div>

            <div v-if="editing" class="editingBox">
                <div class="toolbar">
                    <span v-if="dialog.editor && dialog.created && this.$store.claims.users & 1" class="badge center tooltipped" data-badge-caption=""
                        data-position="top" :data-tooltip="creationInfo">{{editor}}</span>
                    <i @click="edit()" class="material-icons prefix grey-text text-darken-1">undo</i>
                    <i @click="saveTranslationEdit()" class="material-icons prefix grey-text text-darken-1">save</i>
                </div>
                <div class="edit-content-div">
                    <div style="padding-top:2em;padding-right:0.4em">
                        <span class="number-badge">{{itemNumber}}</span>
                        <i class="material-icons prefix helen-green-text">{{icon}}</i>
                    </div>
                    <div class="edit-flexed">
                        <div class="input-field" >
                            <textarea type="text" v-model="editingPhraseText" :style="'height:'+setRows(dialog.id)+'rem'"></textarea>
                        </div>
                        <div dir="auto" class="secondary-language" :id="'secondary-translation-edit-' + dialog.id"> {{ secondaryTranslation }} </div>
                    </div>
                </div>
                <div v-if="dialog.type === 'answer'" class="answer-types">
                    <p>Input type</p>
                    <label v-for="(value, type) in inputTypes" :key="type">
                        <input type="checkbox" :id="type" :value="value" v-model="editingDialog.tags" class="filled-in" disabled="disabled">
                        <span :for="type">{{type}}</span>
                    </label>
                </div>
            </div>

            <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <translateTreeItem v-for="(id, index) in dialog.next" :key="index" :itemNumber="isStart ? (index+1).toString() : itemNumber+'.'+(index+1)" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage" :parentOpen="open" :dialog="nextDialogs[id]" v-if="nextDialogs[id]"
                />
            </ul>
            <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <translateTreeItem v-for="(d, key) in dialogChild" :key="key" :itemNumber="isStart ? (key+1).toString() : itemNumber+'.'+(key+1)" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage" :parentOpen="open" :dialog="d" />
            </ul>
            <ul v-show="open && isEmpty" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <li class="grey-text text-darken-1 text-preview">Empty</li>
            </ul>
        </div>
        <Spinner v-if="loading" :size="'tiny'" />
    </li>
</template>

<style scoped>
    .start {
        padding-left: 0em
    }

    ul.start > li> div > ul  li {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        margin-bottom: -1px
    }

    .center {
        position: relative;
        margin-left: -50%;
        left: -50%;
    }
    .secondary-language{
        color: #757575 !important
    }
    .answer-types>label {
        margin-right: 1em
    }

    .answer-types>p {
        color: darkgray
    }

    .icon-spacer {
        width: 24px;
        height: 24px;
        margin-left: 15px
    }

    .dialog-tree-list {
        list-style-type: none;
    }

    .text-preview {
        white-space: nowrap;
        padding-top: 0.4em;
        padding-bottom: 0.4em;
        padding-right: 72px;
    }

    .dialog-tree-row {
        cursor: pointer;
        padding-left: 0;
    }

    .material-icons {
        display: inline-flex;
        vertical-align: top;
        user-select: none;
    }

    .editingBox {
        border: 1px solid lightgray;
        padding: 0em 1em 0em 1em;
        margin-right: -1em
    }

    .edit-icons{
        position: relative;
    }
    .icon-container{
        position: absolute;
        right: 0;
        top: 0.4em;
    }
    .toolbar {
        text-align: right;
        margin: 0em -1em 0em -1em;
        padding: 0.5em 1em 0.5em 1em;
        border-bottom: 1px solid lightgray;
    }

    .toolbar>i {
        margin-left: 0.5em;
    }

    .toolbar>i:hover {
        color: #6EB2BD !important
    }

    .toolbar>.left {
        margin-left: 0
    }

    .toolbar>.left:hover {
        color: #e57373 !important
    }
    .number-badge{
        font-weight: 300;
        color: #fff;
        background-color: grey;
        border-radius: 2px;     padding: 0 6px;
        vertical-align: top
    }
    .preview-div{
        display: inline-block; 
        white-space: normal;
        padding-right: 72px;
    }
    .edit-content-div {
        display: flex;
    }
    .edit-flexed {
        flex-grow: 1;
        padding-bottom: 1em;
    }
</style>
<script>
    import DropDown from "./DropDown";
    import Modal from "./Modal";
    import Spinner from "./Spinner";
    export default {
        name: "translateTreeItem",
        props: {
            dialog: Object,
            parentOpen: Boolean,
            secondaryLanguage: String,
            itemNumber: String,
            displaySecondaryLanguage:Boolean,
        },
        components: {
            DropDown,
            Modal,
            Spinner
        },
        data() {
            return {
                currentPhraseList: [],
                isEmpty: false,
                dialogDataLoaded:true,
                dialogChild:[],
                open: false,
                phrase: {},
                nextDialogs: {},
                editing: false,
                editingDialog: null,
                editingPhraseText: '',
                showDeleteModal: false,
                loadingDialogs: true,
                loadingPhrase: true,
                initalized: false,
                inputTypes: {
                    "Multi-select": "multiselect",
                    "Number": "input_number",
                },
                dropdownActions: {
                    Category: () => {
                        this.addDialog('category')
                    },
                    Question: () => {
                        this.addDialog('question')
                    },
                    Instruction: () => {
                        this.addDialog('instruction')
                    },
                    Answer: () => {
                        this.addDialog('answer')
                    }
                },
                deleteModalActions: {
                    Yes: () => {
                        this.removeDialog(this.dialog)
                        this.showDeleteModal = false
                    },
                    No: () => {
                        this.showDeleteModal = false
                    },
                }
            }
        },
        watch: {
            parentOpen: function (isOpen) {
                if (!isOpen) {
                    this.open = false
                } else if (!this.initialized) {
                    this.getNext().then(() => this.loadingDialogs = false).catch(() => this.loadingDialogs = false)
                    this.initialized = true
                }
            },
            'dialog.phrase': function (id) {
                this.getPhraseByID(id)
            },
            'dialog.next': function (list) {
                this.nextDialogs = Object.keys(this.nextDialogs).filter((d) => {
                    return this.dialog.next.indexOf(this.nextDialogs[d].id) > -1 || this.nextDialogs[d].new;
                }).reduce((obj, key) => {
                    obj[key] = this.nextDialogs[key];
                    return obj;
                }, {});
                var newDialogs = []
                this.dialog.next.forEach(id => {
                    if (!this.nextDialogs[id]) {
                        newDialogs.push(id)
                    }
                });
                newDialogs.forEach(element => {
                    this.getDialogByID(element)
                });
            }
        },
        mounted(){
            this.open = false
        },
        methods: {
            saveReminder(){
                var rID = this.getRootId();
                var rName = this.getRootName();
                this.$set(this.$store.unsavedChangesInRoot, rName, rID);
                console.log(this.$store.unsavedChangesInRoot);
            },
            getRootName(){
                var rootName = "";
                var dialog = this;
                if (this.dialog.parent == null) {
                    rootName = this.dialog.phrase;
                    return rootName;
                }
                while (true) {
                    var parent = dialog.$parent;
                    dialog = parent;
                    rootName = dialog.dialog.phrase;
                    if (parent.dialog.tags && parent.dialog.tags.indexOf("start") >= 0)
                        break;
                }
                return rootName;
            },
            getRootId(){
                var rootId = "";
                var dialog = this;
                if (this.dialog.parent == null) {
                    rootId = this.dialog.id;
                    return rootId;
                }
                while (true) {
                    var parent = dialog.$parent;
                    dialog = parent;
                    rootId = dialog.dialog.id;
                    if (parent.dialog.tags && parent.dialog.tags.indexOf("start") >= 0)
                        break;
                }
                return rootId;
            },
            getDialogsChild(dialog){
                var instance = ""
                var currentRoot = ''
                this.dialogChild = []
                if(dialog != null || dialog != undefined){
                    if(dialog.tags != null){
                        dialog.tags.forEach(element => {
                            if(element.includes("start_")){
                                currentRoot = element
                                var myString = element.split("start_")
                                instance = myString[1]
                            }
                        });
                    }
                }return new Promise((resolve, reject) => {
                    if(instance != "" && dialog.id != ""){
                        this.$http.get("/dialogs?instance="+instance+"&parent=" + dialog.id).then(
                            r =>{
                                if(r != null){
                                    r.data.forEach(element => {
                                        this.dialogChild.push(element)   
                                    });
                                }
                            },
                            r =>{
                                reject(r)
                            }
                        )}
                        })
            },

            async getNextDialogs(id){
                return new Promise((resolve, reject) =>{
                    this.dialogChild = []
                    var root = ""
                    this.$http.get("/dialogs?parent=" + id).then(
                        response =>{
                            if(response.data !=null){
                                response.data.forEach(element => {
                                    this.dialogChild.push(element)
                                });
                                this.isEmpty = false
                            }else{
                                this.dialogChild == []
                                this.isEmpty = true
                            }
                            resolve(response)
                        })
                        response =>{
                            reject(response)
                        }
                    })
                },

            setRows(id){
                var target = document.getElementById("secondary-translation-" + id) ? document.getElementById("secondary-translation-" + id) : document.getElementById("secondary-translation-edit-" + id) ;
                if(!target) return 4;
                var style = window.getComputedStyle(target, null);
                var height = parseInt(style.getPropertyValue("height"));
                var font_size = parseInt(style.getPropertyValue("font-size"));
                var line_height = parseInt(style.getPropertyValue("line-height"));
                var box_sizing = style.getPropertyValue("box-sizing");
  
                if(isNaN(line_height)) line_height = font_size * 1.2;
 
                if(box_sizing=='border-box')
                {
                    var padding_top = parseInt(style.getPropertyValue("padding-top"));
                    var padding_bottom = parseInt(style.getPropertyValue("padding-bottom"));
                    var border_top = parseInt(style.getPropertyValue("border-top-width"));
                    var border_bottom = parseInt(style.getPropertyValue("border-bottom-width"));
                    height = height - padding_top - padding_bottom - border_top - border_bottom
                }
                var lines = Math.ceil(height / line_height);
                return lines < 5 ? 4*lines : 2*lines;
            },
            /**
             * Toggle folder state
             */
            toggle() {
                this.open = !this.open;
                if(this.open && this.dialogDataLoaded){
                    this.loadingDialogs = true
                    this.dialogDataLoaded = false
                    this.getNextDialogs(this.dialog.id) 
                    this.loadingDialogs = false
                }
            },
            /**
             * Fetch dialog based on ID
             * @param {string} id ID of dialog to fetch
             */
            getDialogByID(id) {
                return new Promise((resolve, reject) => {
                    this.$http.get("/dialogs/" + id).then(
                        response => {
                            if (!response.data.next)
                                response.data.next = []
                            this.$set(this.nextDialogs, id, response.data)
                            resolve()
                        },
                        response => {
                            reject()
                        }
                    );
                })
            },
            /**
             * Fetch phrase based on ID
             * @param {number} id ID of pharse to fetch
             */
            getPhraseByID(id) {
                return new Promise((resolve, reject) => {
                    if (!id) {
                        resolve()
                        return
                    }
                    const storedPhrase = this.$store.phrases.filter(p => p.id === id)[0]
                    if (storedPhrase) {
                        this.phrase = storedPhrase
                        resolve()
                    } else
                        this.$http.get("/phrases/" + id).then(
                            response => {
                                this.phrase = response.data;
                                resolve()
                            },
                            response => {
                                reject()
                            }
                        );

                })
            },
            /**
             * Append a new dialog with the this dialog as parent
             * @param {string} type The type of the new dialog
             */
            addDialog(type) {
                this.open = true
                const tempID = Math.random().toString(36).substr(2, 9)
                this.$set(this.nextDialogs, tempID, {
                    id: tempID,
                    new: true,
                    editor: this.$store.userID,
                    creator: this.$store.userID,
                    phrase: null,
                    next: [],
                    tags: [],
                    type: type
                })
            },
            /**
             * Toggle editing state
             */
            edit() {
                M.toast({"html":"Please use missing translations to edit phrases.","classes":"green"});
                return;
                this.editing = !this.editing
                if (this.editing) {
                    this.editingDialog = Object.assign({}, this.dialog)
                    this.editingPhraseText = this.primaryEditingTranslation
                    this.editingDialog.tags = this.editingDialog.tags == undefined ? [] : this.editingDialog.tags
                    this.editingDialog.editor = this.$store.userID
                }
            },
            /**
             * Call for saving changes to current phrase
             */
            saveTranslationEdit() {
                if (this.editingPhraseText.length < 1) {
                    this.toast('You can\'t save an empty translation')
                    return
                }
                var keys = Object.keys(this.phrase)
                var translation = {
                            text: "",
                            language: this.$store.preferredLanguage,
                        }
                translation.text = this.editingPhraseText
                this.$store.putTranslation(this.phrase.id,translation).then( p => {
                    this.phrase = p
                    this.saveReminder();
                }).catch(() => this.toast('Could not update translation'))
                this.editing = false
            },
            /**
             * Prepare a phrase for posting and if success add it to the store
             * @param {string} translationText Text of translation
             * @param {string} translationLanguage Language of translation
             */
            createNewPhrase(translationText, translationLanguage) {
                return new Promise((resolve, reject) => {
                    var phrase = {
                        translations: [{
                            text: translationText,
                            language: translationLanguage,
                        }]
                    }
                    this.$store.postPhrase(phrase).then(id => {
                        phrase.id = id
                        resolve(id)
                    }).catch(() => reject(Error("Could not add phrase")))
                })
            },
            /**
             * Retireves the next dialogs
             */
            getNext() {
                return new Promise((resolve, reject) => {
                    var a = this.dialog.next.map(id => {
                        return this.getDialogByID(id)
                    });
                    Promise.all(a).then(() => resolve());
                })
            },
            toast(text) {
                M.toast({
                    html: text
                })
            },

            editParagraph(phrase,index){
                M.toast({"html":"Please use missing translations to edit phrases.","classes":"green"});
                return;
                var displayBox = phrase.id + "_" + index + this.$parent.dialog.id + '_' + "span"
                var editbox = phrase.id + "_" + index + this.$parent.dialog.id + '_' + "editbox"
                document.getElementById(displayBox).style.display = "none"
                document.getElementById(editbox).style.display = "flex"
            },

            async getParaGraphPhrase(dialog){
                this.currentPhraseList = [];
                for(var i = 0; i< dialog.tags.length; i++){
                    var tag = dialog.tags[i];
                    if(tag.includes("phrase_")){
                        tag = tag.split("_")
                        var phraseId = tag[tag.indexOf("phrase") + 1];
                        var index = tag[tag.indexOf("index") + 1];
                        
                        await this.getPhraseByIDParagraph(phraseId);
                        
                        var phrase = this.$store.phrases[phraseId];
                        this.$store.paragraphPhrases.forEach(element => {
                            if(element.id == phraseId){
                                this.currentPhraseList.push(element)
                            }
                        });
                    }
                }
                this.loadingDialogs = false;
            },
            getPhraseByIDParagraph(id){
                return new Promise((resolve, reject) => {
                    if (!id) {
                        resolve();
                        return;
                    }
                    this.$http.get("/phrases/" + id).then(
                        response => {
                            this.$store.paragraphPhrases.push(response.data);
                            resolve(response.data);
                        },
                    response => {
                        reject();
                    });
                });
            },
            primaryPraragraphTranslation(phrase) {
                if (phrase.translations)
                var foundTranslation = phrase.translations.filter(
                    t => t.language === this.$store.preferredLanguage)[0];
                    if (foundTranslation) return foundTranslation.text;
                    return foundTranslation
                    ? foundTranslation.text
                    : "Phrase has no translation for this language";
            },
            secondaryParagraphTranslation(phrase) {
                if (phrase.translations)
                var foundTranslation = phrase.translations.filter(
                    t => t.language === this.secondaryLanguage)[0];
                    if (foundTranslation) return foundTranslation.text;
                    return foundTranslation
                    ? foundTranslation.text
                    : "Phrase has no translation for this language";
            },
            undoEditParagraph(phrase,index){
                var displayBox = phrase.id + "_" + index + this.$parent.dialog.id + '_' + "span"
                var editbox = phrase.id + "_" + index + this.$parent.dialog.id + '_' + "editbox"
                document.getElementById(displayBox).style.display = "flex"
                document.getElementById(editbox).style.display = "none"
            },

            savePhrase(phrase,index){
                var phraseValue = phrase.id + "_" + index + "textarea"
                var inputValue = this.$refs[phraseValue]
                var input = inputValue[0].value
                
                this.updatePhrase(input,this.$store.preferredLanguage,phrase)
                
                this.loadingDialogs = false;
                this.undoEditParagraph(phrase,index)
            },
            
            updatePhrase(translationText, translationLanguage,phrase) {
                return new Promise((resolve, reject) => {
                    phrase.translations.forEach(element => {
                        if(element.language == translationLanguage){
                            element.text = translationText
                        }else{
                            var obj = {
                                text: translationText,
                                language: translationLanguage
                            }
                            phrase.translations.push(obj)
                        }
                    });
                    this.$store
                    .putPhrase(phrase)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(() => reject(Error("Could not add phrase")));
                });
            },
        },
        /**
         * Intitialize the component
         */
        created() {
            if (this.isStart)
                this.open = true
            if (this.dialog.new)
                this.edit()
            if(this.dialog.tags && this.dialog.tags.indexOf("start") >= 0){
                this.loadingPhrase = false;
            }
            else
                this.getPhraseByID(this.dialog.phrase).then(() => this.loadingPhrase = false).catch(() => this.loadingPhrase =
                    false)
            if (this.parentOpen) {
                    this.loadingDialogs = false;
                    this.initialized = true;
            }

            if(this.dialog.tags != undefined){
                this.currentPhraseList = []
                if(this.dialog.tags.includes("paragraph")){
                    this.$store.paragraphPhrases = []
                    this.getParaGraphPhrase(this.dialog);
                }else{
                    this.loadingDialogs = false
                }
            }else{
                    this.loadingDialogs = false;
            }
        },
        /**
         * Handle Materialize components on graphical update
         */
        updated() {
            var tooltips = document.querySelectorAll('.tooltipped');
            if (tooltips)
                M.Tooltip.init(tooltips, {})
        },
        computed: {
               /**
             * Get translation based on current preferred language
             */
            secondaryTranslation() {
                if (this.isStart)
                    return ''
                    
                if (this.secondaryLanguage === "")
                    return 'No secondary language is selected'
                    
                if (this.phrase.translations)
                    var foundTranslation = this.phrase.translations.filter(t => t.language === this.secondaryLanguage)[
                        0]
                if (foundTranslation)
                    return foundTranslation.text
                return foundTranslation ? foundTranslation.text : 'Phrase has no translation for the secondary language'
            },
            /**
             * Get translation based on current preferred language
             */
            primaryTranslation() {
                if (this.isStart) return this.dialog.phrase;
                if (this.phrase.translations)
                    var foundTranslation = this.phrase.translations.filter(t => t.language === this.$store.preferredLanguage)[
                        0]
                if (foundTranslation)
                    return foundTranslation.text
                return foundTranslation ? foundTranslation.text : 'Phrase has no translation for this language'
            },
          
            /**
             * Get translation based on current preferred language (if none found => '')
             */
            primaryEditingTranslation() {
                if (this.phrase.translations)
                    var foundTranslation = this.phrase.translations.filter(t => t.language === this.$store.preferredLanguage)[
                        0];
                return foundTranslation ? foundTranslation.text : ''
            },
            /**
             * Get icon based on dialog's type
             */
            icon() {
                const types = {
                    'answer': 'chat',
                    'instruction': 'feedback',
                    'question': 'help',
                    'category': 'folder',
                    'start': 'view_list',
                    'default': 'error'
                }
                return (types[this.dialog.type] || types[this.isStart ? 'start' : 'default'])
            },
            /**
             * Returns last editor of dialog
             */
            editor() {
                const modifier = this.$store.users.filter(u => u.id === this.dialog.editor)[0]
                return modifier ? modifier.username : ''
            },
            creationInfo() {
                const creator = this.$store.users.filter(u => u.id === this.dialog.creator)[0]
                return creator && this.dialog.created ? "Created by " + creator.username + " ( " + this.dialog.created.split(
                    'T')[0] + " " + this.dialog.created.split('T')[1].slice(0, 5) + " )" : ''
            },
            /**
             * Get empty state of nextDialogs
             */
            empty() {
                for (var key in this.nextDialogs) {
                    if (this.nextDialogs.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            /**
             * Returns if dialog is start-dialog
             */
            isStart() {
                return this.dialog.tags && this.dialog.tags.indexOf('start') > -1
            },
            /**
             * Returns if the dialog is loading
             */
            loading() {
                return this.loadingPhrase || this.loadingDialogs
            }
        },
    }
</script>